
<div class="card-container">
    <mat-card class="example-card">
    <mat-card-header *ngIf="!isEvaluaciones">
        <mat-card-title>Gestor de expediente médico</mat-card-title>
        <mat-card-subtitle>Localiza y consulta de expediente médico</mat-card-subtitle>
    </mat-card-header>
    <mat-card-header *ngIf="isEvaluaciones">
        <mat-card-title>Gestor general de evaluaciones</mat-card-title>
        <!--<mat-card-subtitle>Localiza y consulta beneficiarias</mat-card-subtitle>-->
    </mat-card-header>
    <mat-card-content>
        <form (ngSubmit)="sF()" autocomplete="off" [formGroup]="formulario">
            <mat-form-field appearance="fill" class="bt col-md-6">
                <mat-label>Buscador</mat-label>
                <input matInput placeholder="Nombre de la beneficiaria" formControlName="buscar">
                
            </mat-form-field>
            &nbsp;
            <mat-form-field appearance="fill" class="bt col-md-4">
                <mat-label>Etapa</mat-label>
                <mat-select formControlName="estatus">
                    <mat-option value="">-- Seleccione una opción --</mat-option>
                    <mat-option *ngFor="let estado of estados" value="{{estado.valor.replace(' ','_') | uppercase}}">{{estado.valor}}</mat-option>
                </mat-select>
            </mat-form-field>
            <button type="submit" mat-mini-fab color="accent">
                <mat-icon>search</mat-icon>
            </button>

            <br/>
            <!--<button type="button" color="primary" class="flat" mat-flat-button [routerLink]="['datos-generales']" *ngIf="!isEvaluaciones && tieneAccionCrear; else elseButtonNew">
                <mat-icon>add</mat-icon>Nuevo expediente
            </button>
            <ng-template #elseButtonNew>
                <button type="button" color="primary" class="flat" mat-flat-button disabled>
                    <mat-icon>add</mat-icon>Nuevo expediente
                </button>
            </ng-template>
            &nbsp;-->
            <a type="button" download="reporte-beneficiarias.xls" color="accent" class="flat" mat-flat-button *ngIf="!isEvaluaciones" href="{{phpPath}}/reportBeneficiarias.php">
                <mat-icon>list_alt</mat-icon>&nbsp;Reporte en excel
            </a>
            <!--&nbsp;
            <a  color="accent" class="flat" mat-flat-button  href="{{laravelapi}}/ReporteExcelBeneficiario" target="_blank" rel=noopener>
                <mat-icon>list_alt</mat-icon>&nbsp;Reporte en excel sobre el estado
            </a>-->
        </form>
        
        <div class="table-container">
            <div class="spinner" *ngIf="isLoading">
                <mat-spinner color="accent"></mat-spinner>
            </div>
            <table mat-table [dataSource]="dataSource">
                <caption></caption>
                <!--- Note that these columns can be defined in any order.
                    The actual rendered columns are set as a property on the row definition" -->
            
                <!-- Position Column -->
                <ng-container matColumnDef="gexm_position">
                    <th id="gexm_position" mat-header-cell *matHeaderCellDef> # </th>
                    <td mat-cell *matCellDef="let element;let i=index"> {{i+1}} </td>
                </ng-container>


                <ng-container matColumnDef="gexm_nombre">
                <th id="gexm_nombre" mat-header-cell *matHeaderCellDef> Nombre </th>
                <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
                </ng-container>
            
                <!-- Estatus Column -->
                <ng-container matColumnDef="gexm_estatus">
                <th id="gexm_estatus" mat-header-cell *matHeaderCellDef> Estatus </th>
                <td mat-cell *matCellDef="let element"> 
                    <mat-chip-list aria-label="Fish selection">
                        <mat-chip color="primary" class="active" selected *ngIf="filtroEstatus(element.etapaAtencionActiva)=='ACTIVO'; else NoActivo">
                            <mat-icon>done</mat-icon>Activo
                        </mat-chip>
                        <ng-template #NoActivo>
                            <mat-chip #NoActivo>
                                <mat-icon>history</mat-icon>No activo
                            </mat-chip>
                        </ng-template>
                        
                    </mat-chip-list>
                </td>
                </ng-container>
            
                <ng-container matColumnDef="gexm_etapa">
                    <th id="gexm_etapa" mat-header-cell *matHeaderCellDef> Etapa </th>
                    <td mat-cell *matCellDef="let element">
                        {{co(element.etapaAtencionActiva)}}
                    </td>
                </ng-container>
                <!-- Weight Column -->
                <ng-container matColumnDef="gexm_motivo_ingreso">
                <th id="gexm_motivo_ingreso" mat-header-cell *matHeaderCellDef> Motivo de ingreso </th>
                <td mat-cell *matCellDef="let element"> {{getMotivoIngresoById(element.idMotivoIngreso)}} {{element.desMotivoIngreso}} </td>
                </ng-container>
            
                <!-- Symbol Column -->
                <ng-container matColumnDef="gexm_discapacidad">
                <th id="gexm_discapacidad" mat-header-cell *matHeaderCellDef> Discapacidad </th>
                <td mat-cell *matCellDef="let element"> {{element.idDiscapacidad}} </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="gexm_canalizador">
                <th id="gexm_canalizador" mat-header-cell *matHeaderCellDef> Canalizador </th>
                <td mat-cell *matCellDef="let element"> {{getCanalizadorById(element?.idCanaliza)}} {{element.desCanaliza}} </td>
                </ng-container>

                <ng-container matColumnDef="gexm_mas">
                    <th id="acciones" mat-header-cell *matHeaderCellDef> Acciones </th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-icon-button [matMenuTriggerFor]="menu">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item [routerLink]="['/medico/expedientes-medicos/gestor-expedientes-medicos/consultar']" [queryParams]="{id: element.id}">
                                <mat-icon>folder</mat-icon>
                                <span>Ver Historial clínico</span>
                            </button>
                            <button mat-menu-item [routerLink]="['/medico/expedientes-medicos/gestor-expedientes-medicos/registrar']" [queryParams]="{id: element.id}">
                                <mat-icon>folder</mat-icon>
                                <span>Editar Historial clínico</span>
                            </button>
                            <button mat-menu-item [routerLink]="['/medico/expedientes-medicos/gestor-expedientes-medicos/gestor-eyt']" [queryParams]="{id: element.id}" >
                                <mat-icon>folder</mat-icon>
                                <span>Eventos médicos</span>
                            </button>
                            <button mat-menu-item  [routerLink]="['/medico/expedientes-medicos-generales/gt-expedientes-medicos-generales-ben/consultar']" [queryParams]="{id: element.id}">
                                <mat-icon>insights</mat-icon>
                                <span>Ver Control peso y talla</span>
                            </button>
                            <!--<button mat-menu-item  [routerLink]="['/medico/expedientes-medicos-generales/gt-expedientes-medicos-generales-ben/modificar']" [queryParams]="{id: element.id}">
                                <mat-icon>insights</mat-icon>
                                <span>Control peso y talla</span>
                            </button>-->
                            <button mat-menu-item [routerLink]="['/medico/expedientes-medicos/control-vacunacion/consultar']" [queryParams]="{id: element.id, f_c: element?.fechaNacimiento?.date}">
                                <mat-icon>insights</mat-icon>
                                <span>Control vacunación</span>
                            </button>
                            <button mat-menu-item [routerLink]="['/medico/expedientes-medicos/gt-terapias-companas']"  [queryParams]="{id: element.id}">
                                <mat-icon>event</mat-icon>
                                <span>Terapia / Campaña</span>
                            </button>
                            <button mat-menu-item [routerLink]="['/medico/expedientes-medicos/gt-impresion-expdiente-medico/consultar']" [queryParams]="{id: element.id, fecha_temporal: element?.fechaAlta?.date}">
                                <mat-icon>event</mat-icon>
                                <span>Impresión expediente médico</span>
                            </button>
                        </mat-menu>
                    </td>
                </ng-container>

                <ng-container matColumnDef="gexm_habilidades">
                    <th id="gexm_habilidades" mat-header-cell *matHeaderCellDef> Habilidades </th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-icon-button color="primary" [routerLink]="['gestor-de-pruebas']" [queryParams]="{id: element.id}">
                            <mat-icon>preview</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <ng-container matColumnDef="gexm_general">
                    <th id="datosGenerales" mat-header-cell *matHeaderCellDef> Datos generales </th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-mini-fab color="warn">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container>
                <ng-container matColumnDef="gexm_expediente">
                    <th id="gexm_expediente" mat-header-cell *matHeaderCellDef> Expediente </th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-mini-fab color="warn">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container>
                
                <ng-container matColumnDef="gexm_eventos">
                    <th id="gexm_eventos_vida" mat-header-cell *matHeaderCellDef> Eventos de vida </th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-mini-fab color="warn">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container>
                <ng-container matColumnDef="gexm_eliminar">
                    <th id="gexm_eliminar" mat-header-cell *matHeaderCellDef> Eliminar </th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-mini-fab color="warn">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container>
            
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
          

    </mat-card-content>
    <mat-card-actions>

        <mat-paginator
            [pageSize]="paginador.pageSize"
            [pageSizeOptions]="paginador.pageOptions"
            (page)="pr($event)">
        </mat-paginator>

    </mat-card-actions>
    </mat-card>
</div>

